import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "site-widget"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = {
  id: "chart",
  class: "chart-width"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWidget = _resolveComponent("HeaderWidget")!
  const _component_PieChart = _resolveComponent("PieChart")!
  const _component_ElevatedCard = _resolveComponent("ElevatedCard")!

  return (_openBlock(), _createBlock(_component_ElevatedCard, {
    widthType: _ctx.WidthType.third
  }, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderWidget, {
        iconUrl: _ctx.loadIcon,
        "mode-edition": true,
        sizeIcon: 35,
        subtitle: _ctx.$t('requestInterventionWidget.subtitle'),
        title: _ctx.widget.libelle,
        onDupliquer: _ctx.dupliquer,
        onFiltre: _ctx.filtre,
        onSuppression: _ctx.suppression
      }, null, 8, ["iconUrl", "subtitle", "title", "onDupliquer", "onFiltre", "onSuppression"]),
      _createElementVNode("div", null, [
        (_ctx.widget.sites == null || _ctx.widget.sites.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t('multisites')), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.widget.sites, (site) => {
              return (_openBlock(), _createElementBlock("span", {
                key: site.id,
                class: "site-widget"
              }, [
                _createTextVNode(_toDisplayString(site.description) + " ", 1),
                (site.id !== _ctx.widget.sites[_ctx.widget.sites.length - 1].id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, ", "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createBlock(_component_PieChart, {
            key: _ctx.isLoading,
            colors: [_ctx.getColorEnCours(), _ctx.getColorPlanifie(), _ctx.getColorNonPlanifie()],
            isLoading: false,
            isPercentage: false,
            labels: [
                        _ctx.$t('requestInterventionWidget.inProgress'),
                        _ctx.$t('requestInterventionWidget.planned'),
                        _ctx.$t('requestInterventionWidget.unplanned'),
                        _ctx.$t('requestInterventionWidget.traitees'),
                    ],
            seriesValues: _ctx.series,
            showDataLabels: true,
            showLegend: true,
            onDataPointClicked: _ctx.naviguerVersRecherche
          }, null, 8, ["colors", "labels", "seriesValues", "onDataPointClicked"]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["widthType"]))
}